import { prop, modify, isNil } from 'ramda';

export const ensurePhonesArray = (data) =>
  isNil(prop('phones', data))
    ? modify('phones', () => [{ internationalCode: '+33' }], data)
    : data;
